(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["delivery-info"] && !Shopify.designMode) return;
  try {
    (function() {
    function getWeightCombo(picker) {
      return Array.from(
        picker.querySelectorAll('fieldset input:checked[data-option-value-id], select option:checked[data-option-value-id]')
      ).map(function(el) { return el.dataset.optionValueId; }).join(',');
    }

    function updateWeight() {
      document.querySelectorAll('[data-weight-item]').forEach(function(li) {
        try {
          var map = JSON.parse(li.dataset.weightMap || '{}');
          var picker = document.querySelector('variant-picker');
          if (!picker) return;
          var combo = getWeightCombo(picker);
          if (!combo) return;
          var w = map[combo];
          var el = li.querySelector('[data-weight-display]');
          if (!el) return;
          if (w > 0) {
            el.textContent = w >= 1000 ? Math.round(w / 1000) + ' kg' : w + ' g';
            li.hidden = false;
          } else {
            li.hidden = true;
          }
        } catch(err) {}
      });
    }

    document.addEventListener('variant:selected', updateWeight);
    document.addEventListener('variant:update', updateWeight);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["resource-list-carousel"] && !Shopify.designMode) return;
  try {
    (function () {
  function setup(carousel) {
    var scroller = carousel.querySelector('slideshow-slides');
    var allSlides = carousel.querySelectorAll('slideshow-slide');
    if (!scroller || allSlides.length < 2) return;

    var first = allSlides[0];
    var last = allSlides[allSlides.length - 1];

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === first) carousel.toggleAttribute('at-start', entry.isIntersecting);
          if (entry.target === last) carousel.toggleAttribute('at-end', entry.isIntersecting);
        });
      },
      { root: scroller, threshold: 0.5 }
    );

    io.observe(first);
    io.observe(last);
  }

  function initAll() {
    document
      .querySelectorAll('.resource-list__carousel slideshow-component:not([infinite])')
      .forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    // Auto-sélectionner les options recommandées si aucun variant dans l'URL
  (function () {
    function applyRecommended() {
      if (new URLSearchParams(window.location.search).has('variant')) return;
      document.querySelectorAll('input[data-recommended="true"]').forEach(function (input) {
        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { requestAnimationFrame(applyRecommended); });
    } else {
      requestAnimationFrame(applyRecommended);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
